import React, { useState } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap"
import ScrollAnimation from 'react-animate-on-scroll';
import "./FeaturedEvent.scss";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import HTMLReactParser from "html-react-parser";
import ReapitBook from "../ReapitBook";
import EventbritePopupCheckout from "../EventBrite";
import Google from "../../images/google-white.png";
import moment from "moment";
import ContactFormPage from "../forms/contact";
import { isMobile, isDesktop } from "react-device-detect";
import { Link } from "gatsby";
import BookYourTicket from "../EventBanner/BookYourTicket";
import PlayVideo from "../PlayVideo/PlayVideo";
import { convertBrToP } from '../../components/common/htmlUtils';

const FeaturedEvent = (props) => {
	const [isPlay, setPlay] = useState(false);
    const [isPlaying, setPlaying] = useState(false);
    const [show, setShow] = useState(false);
    let titleText = "";
    if(props?.data?.Title) {
        titleText = props?.data?.Title.replace(props?.data?.Italic_Text, `<i>${props?.data?.Italic_Text}</i>`)
        titleText = HTMLReactParser(titleText)
    }

	return (
		<React.Fragment>
			<section className={`featured-event ${props?.className || ""}`} id="featured-event">
				<Container>
					<Row className="flex-column flex-lg-row">
						<Col lg="6">
							<ScrollAnimation animateIn="fadeInLeft">
								<div className="featured-content">
									<span className="sub-title">{props?.data?.Sm_Title}</span>
                                    {props.events ? 
                                        <Link to={props?.data?.Link}>
									        <h2>{titleText}</h2>
                                        </Link>
                                    :
									    <h2>{titleText}</h2>
                                    }
                                    
                                    {props?.data?.Content && <div className="content">{HTMLReactParser(convertBrToP(props?.data?.Content))}</div>}

                                    <div className="featured-img img-zoom d-lg-none d-block mb-5">
                                        <GatsbyImage
                                            image={getImage(props?.data?.Tile_Image?.url_sharp)}
                                            alt={props?.data?.Tile_Image?.alternativeText ? props?.data?.Tile_Image?.alternativeText : props?.data?.Sm_Title+" - tlc Estate Agents"}
                                            className="h-100 w-100"
                                        />
                                        {(props?.data?.Video_Url && !isPlay) && 
                                        <button type="button" className="play-btn" onClick={() => { setPlay(true) }}>
                                            <i className="video-icon"></i>
                                        </button>}
                                    </div>
								</div>
								{props?.data?.Select_Team && 
                                <div className="event-organizer">
                                    {props?.data?.Select_Team && <div className="img-wrap img-zoom">
										{/* <img 
                                            src={props?.data?.Select_Team?.Tile_Image?.url} 
                                            alt={props?.data?.Select_Team?.Name + " " + props?.data?.Select_Team?.Designation + "- tlc Estate Agents"} 
                                        /> */}
                                        <GatsbyImage
                                            image={getImage(props?.data?.Select_Team?.Tile_Image?.url_sharp)}
                                            alt={props?.data?.Select_Team?.Name + " " + props?.data?.Select_Team?.Designation + "- tlc Estate Agents"} 
                                        />
										{props?.data?.Select_Team?.Video_Url && <button type="button" className="play-btn" onClick={() => { setPlaying(true) }}>
											<i className="video-icon"></i>
										</button>}
									</div>}
									{props?.data?.Select_Team && <div className="organizer-info">
										<div className="organizer-name">{props?.data?.Select_Team?.Name}</div>
										<div className="organizer-post">{props?.data?.Select_Team?.Designation}</div>
										<div className="link-wrap">
											<div className="organizer-contact">
												<div className="wrap-icon">
													<i className="icon-mail"></i>
												</div>
												    <a onClick={() => setShow(true)} className="cursor-pointer"> <i className='icon-mail'></i>Email</a>
											</div>
											<div className="organizer-appointment">
												<div className="wrap-icon">
													<i className="icon-mail"></i>
												</div>
												{/* <ReapitBook className="cursor-pointer" type="[&quot;sales&quot;,&quot;lettings&quot;]">
                                                    Book an Appointment
                                                </ReapitBook> */}
                                                {props?.data?.Cta_Label == "Team_Link" ?
                                                    <a className="cursor-pointer" onClick={() => setShow(true)}>
                                                        Book an Appointment
                                                    </a> :
                                                    <ReapitBook className="cursor-pointer" type="[&quot;sales&quot;,&quot;lettings&quot;]">
                                                        Book a Valuation
                                                    </ReapitBook>
                                                }
											</div>
										</div>
									</div>}
								</div>}
                                
                                {props.events && 
                                    <div className={moment().isAfter(props?.data?.Date) ? "d-none" : "d-block"}>
                                        <EventbritePopupCheckout ebEventId={props?.data?.EventId} className={moment().isAfter(props?.data?.Date) ? "" : "cursor-pointer"} disabled={moment().isAfter(props?.data?.Date)} event_item={props?.data}>
                                            <button className="btn d-block btn-outline" disabled={moment().isAfter(props?.data?.Date)}>
                                                Book your Ticket
                                            </button>
                                        </EventbritePopupCheckout>

                                        {/* {
                                            (moment().isAfter(props?.data?.Date) ?
                                                <button type="button" className="btn d-block btn-outline" disabled={true}>Book your Ticket</button>
                                            :
                                                <BookYourTicket data={props?.data} className="btn d-block" btnLabel="Book Your Ticket" />
                                            )
                                        } */}
                                    </div>
                                }
                                {props.events && 
                                    <p className="mt-3 text-light">To see past events and future events <Link to="/local-living/events/" className="text-gold">click here</Link></p>
                                }
                                {props.events && <div className="rating-wrap mob-hide d-block mt-5">
                                    <img src={Google} alt="property-img" style={{ width: 100 }}/>
                                    <span className="rating text-white ps-3">
                                        Rated <span className="review"> 4.9 out of 5 </span>from our valued customers.
                                    </span>
                                </div>}
							</ScrollAnimation>
						</Col>
						<Col lg="6">
							<ScrollAnimation animateIn="fadeInRight h-100 d-lg-block d-none">
								<div className="featured-img img-zoom h-100 w-100">
                                    {/* {props.events ? 
                                        <img src={props?.data?.Tile_Image?.url} className="h-100"/> :     */}
                                        <GatsbyImage
                                            image={getImage(props?.data?.Tile_Image?.url_sharp)}
                                            alt={props?.data?.Tile_Image?.alternativeText ? props?.data?.Tile_Image?.alternativeText : props?.data?.Sm_Title+" - tlc Estate Agents"}
                                            className="h-100 w-100"
                                        />
                                    {/* } */}
									{(props?.data?.Video_Url && !isPlay) && 
                                    <button type="button" className="play-btn" onClick={() => { setPlay(true) }}>
										<i className="video-icon"></i>
									</button>}
                                    
								</div>
							</ScrollAnimation>
						</Col>
                        {(props?.data?.Video_Url && isPlay) && <div className="fullscreen-video">
                            {isPlay && 
                                <React.Fragment>
                                    <div className="d-block">
                                        <PlayVideo
                                            isOpen={isPlay}
                                            videoId={props?.data?.Video_Url}
                                            stopPlay={setPlay}
                                            width={'100%'} height={'100%'}
                                            fullscreen={true}
                                        />
                                    </div>
                                </React.Fragment>
                            }
                        </div>}
					</Row>
				</Container>
                {(props?.data?.Select_Team?.Video_Url && isPlaying) && <div className="full-video">
                    {isPlaying &&
                        <React.Fragment>
                            <div className="d-block">
                                <PlayVideo
                                    isOpen={isPlaying}
                                    videoId={props?.data?.Select_Team?.Video_Url}
                                    stopPlay={setPlaying}
                                    width={'100%'} height={isDesktop ? '600px' : '100%'}
                                    fullscreen={isDesktop ? false : true}
                                    event={"Contact"}
                                />
                            </div>
                        </React.Fragment>
                    }
                </div>}
                <Modal className="form-popup" onHide={() => setShow(false)} show={show} contentClassName="p-0" size="sm">
                    <Modal.Body className="p-5">
                        <div className="card-title h5 text-center mb-3">Contact - {props?.data?.Select_Team?.Name}</div>

                        <button onClick={() => setShow(false)} type="button" className="close-modal">
                            <i className="icon-close-modal"></i>
                        </button> 
                        <div className="form-block career-form">
                            <ContactFormPage email={props?.data?.Select_Team?.Email} formname={`Contact - ${props?.data?.Select_Team?.Name}`}/>
                        </div>
                    </Modal.Body>
                </Modal>
			</section>
		</React.Fragment>
	)
}
export default FeaturedEvent
